module.exports = __webpack_public_path__ + "img/image2.56e80cad.jpg";